// extracted by mini-css-extract-plugin
export default {"range":"Title_range__vxQLJ","popover":"Title_popover__a3M2L"};